module.exports = "/_next/static/images/slide1-2x-bffaa1167af41ac85c8f993f41091cd4.jpg.webp";